<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import { useResourcesStore } from '@/stores/resources'
import { useTr } from '@/composables/useTr'

const app = useAppStore()
const res = useResourcesStore()
const { tr } = useTr()

const findingsFull = computed(() => res.viewFindings)

const count = (sev: string) => findingsFull.value.filter((f) => f.sev === sev).length
const kevCount = computed(() => findingsFull.value.filter((f) => f.kev).length)
const last24h = computed(() => findingsFull.value.filter((f) => f.discovered.includes('h')).length)
</script>

<template>
  <aside class="findings-sub-nav">
    <div class="ssn-header">{{ tr('按严重度', 'By Severity') }}</div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'all' }" @click="app.findingsFilter = 'all'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /></svg></span>
      <span style="flex:1;">{{ tr('全部', 'All') }}</span>
      <span class="badge num">{{ findingsFull.length }}</span>
    </div>
    <div style="height:6px;" />
    <!-- Note: `findingsFull` template ref unwraps the ComputedRef to its underlying array;
         `.length` works directly. Same for kevCount / last24h. -->

    <div class="ssn-item" :class="{ active: app.findingsFilter === 'crit' }" @click="app.findingsFilter = 'crit'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-crit); margin-right:2px;" />
      <span style="flex:1;">Critical</span>
      <span class="badge num">{{ count('crit') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'high' }" @click="app.findingsFilter = 'high'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-high); margin-right:2px;" />
      <span style="flex:1;">High</span>
      <span class="badge num">{{ count('high') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'med' }" @click="app.findingsFilter = 'med'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-med); margin-right:2px;" />
      <span style="flex:1;">Medium</span>
      <span class="badge num">{{ count('med') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'low' }" @click="app.findingsFilter = 'low'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-low); margin-right:2px;" />
      <span style="flex:1;">Low</span>
      <span class="badge num">{{ count('low') }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'info' }" @click="app.findingsFilter = 'info'">
      <span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:var(--sev-info); margin-right:2px;" />
      <span style="flex:1;">Info</span>
      <span class="badge num">{{ count('info') }}</span>
    </div>
    <div class="ssn-header" style="padding-top:14px;">{{ tr('快捷', 'Shortcuts') }}</div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === 'kev' }" @click="app.findingsFilter = 'kev'">
      <span class="chip chip-crit" style="font-size:9px; padding:0 4px; line-height:14px;">KEV</span>
      <span style="flex:1;">{{ tr('已知被利用', 'KEV') }}</span>
      <span class="badge num">{{ kevCount }}</span>
    </div>
    <div class="ssn-item" :class="{ active: app.findingsFilter === '24h' }" @click="app.findingsFilter = '24h'">
      <span class="ssn-icon"><svg fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg></span>
      <span style="flex:1;">{{ tr('最近 24h', 'Last 24h') }}</span>
      <span class="badge num">{{ last24h }}</span>
    </div>
  </aside>
</template>
